export default {
      id: "vague_organiser_b-usage",
      viewBox: "0 0 1200 545",
      url: "../dist/images/" + "sprite.svg#vague_organiser_b-usage",
      toString: function () {
        return this.url;
      }
    }